module.exports = __webpack_public_path__ + "static/img/shop.87d182d.png";